<template>
  <div class="game-tr-step" @click="openPop($event, stepData.index)">
    <div :id="'step_' + stepData.index" class="stepp-button" :style="setConfig()">{{ stepData.id }}</div>
    <b-popover
      :target="'step_' + stepData.index"
      :ref="'step_' + stepData.index"
      :show.sync="show"
      triggers="click"
      :placement="stepData.direction"
    >
      <div class="popover-body-step-text" v-html="stepData.textObj.text" :style="getStyle(stepData.textObj)"></div>
    </b-popover>
  </div>
</template>

<script>
import _ from 'lodash';
import * as utils from '../../../Utils/inputUtilsV2';
export default {
  name: 'tr-step-v2',
  components: {},
  props: {
    config: {
      type: null,
      default: function () {
        return {};
      },
    },
    stepData: {
      type: null,
      default: function () {
        return {};
      },
    },
    showStep: {
      type: null,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      // stepShowValue: this.showStep,
    };
  },
  created() {},
  mounted() {},
  methods: {
    openPop($event, index) {
      this.show = !this.show;
      this.$emit('close-all', $event, { index: index });
      this.$emit('step-change', $event, { index: index, show: this.show });
      return this.show;
    },
    setConfig() {
      return {
        width: this.config.width + 'px',
        height: this.config.height + 'px',
        'font-size': this.config.fontSize + 'px',
        background: this.config.backgroundColor,
        color: this.config.color,
      };
    },
    getStyle(item) {
      item.width = item.width;
      item.height = item.height;
      return _.merge(this.getCustomStyle(item), {
        width: utils.elementWidth(item.width, 'px'),
        height: utils.elementHeight(item.height, 'px'),
      });
    },
    getCustomStyle(item) {
      let customStyle = {};
      if (item.cssStyle) {
        if (_.isObject(item.cssStyle)) {
          customStyle = _.mapKeys(item.cssStyle, function (value, key) {
            return _.toString(key);
          });
        }
      }
      return customStyle;
    },
  },
  computed: {
    show: {
      get() {
        return this.showStep.show;
      },
      set(newValue) {
        // if (!newValue) {
        //   // this.$emit('change');
        //   this.$refs['step_' + this.stepData.id].$emit('close');
        // }
        this.showStep.show = newValue;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/variable';
@import '~@/assets/sass/iconColor';
@import '~@/assets/sass/inputBase';

.game-tr-step {
  .stepp-button {
    border-radius: 100%;
    width: 45px;
    height: 45px;
    font-size: 29px;
    background: #f26f21;
    color: #fff;
    font-family: 'Calibri';
    font-weight: bold;
  }
}
</style>
<style lang="scss">
.popover.bs-popover-auto[x-placement^='top'] .arrow::after,
.popover.bs-popover-top .arrow::after {
  border-top-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='left'] .arrow::after,
.popover.bs-popover-left .arrow::after {
  border-left-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='right'] .arrow::after,
.popover.bs-popover-right .arrow::after {
  border-right-color: #f5f5dc !important;
}
.popover.bs-popover-auto[x-placement^='bottom'] .arrow::after,
.popover.bs-popover-bottom .arrow::after {
  border-bottom-color: #f5f5dc !important;
}
.popover {
  // background-color: #f5f5dc;

  // .arrow::after {
  //
  // }
  .popover-body {
    font-size: 25px;
    font-family: Calibri;
    padding: 0;
    background-color: #f5f5dc;
    // padding: 0.5rem 0.75rem;
    .popover-body-step-text {
      padding: 0.5rem 0.75rem;
      background-color: #f5f5dc;
      // background-color: red;
    }
  }
}
</style>
